"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Marker_1 = require("./Marker");
var SnapshotMarker = (function (_super) {
    tslib_1.__extends(SnapshotMarker, _super);
    function SnapshotMarker(config, rawData, version) {
        return _super.call(this, config, rawData, version) || this;
    }
    return SnapshotMarker;
}(Marker_1.Marker));
exports.SnapshotMarker = SnapshotMarker;
//# sourceMappingURL=SnapshotMarker.js.map